import React, { useEffect, useState } from "react";
import globalModalManager from "../../utils/globalModalManager";
import AvailableSoonModal from "../AvailableSoonModal";
import AlertModal from "../AlertModal";
import ConfirmModal from "../ConfirmModal";

const GlobalModalProvider: React.FC = () => {
  const [modalState, setModalState] = useState(globalModalManager.getState());

  useEffect(() => {
    const unsubscribe = globalModalManager.subscribe(setModalState);
    return unsubscribe;
  }, []);

  const handleClose = () => {
    globalModalManager.closeModal();
  };

  return (
    <>
      <AvailableSoonModal
        open={modalState.isOpen && modalState.type === 'available-soon'}
        onClose={handleClose}
      />
      <AlertModal
        open={modalState.isOpen && modalState.type === 'alert'}
        onClose={handleClose}
        message={modalState.data?.message || ''}
      />
      <ConfirmModal
        open={modalState.isOpen && modalState.type === 'confirm'}
        onClose={handleClose}
        onConfirm={modalState.data?.onConfirm || (() => {})}
        message={modalState.data?.message || ''}
        confirmText={modalState.data?.confirmText}
        cancelText={modalState.data?.cancelText}
        variant={modalState.data?.variant || 'default'}
      />
    </>
  );
};

export default GlobalModalProvider;
